<script lang="ts" setup>
import { ref } from "vue";
import { debounce } from "lodash";
import axios from "axios";
import { appContext } from "@/appContext";

const emit = defineEmits([
  'update:modelValue'
]);

const props = defineProps<{
  value?: any,
  placeholder?: string
}>();

function makeGoogleQueryUrl(address) {
  let params = new URLSearchParams({
    address: address,
    key: appContext.GOOGLE_API_KEY() || '',
    language: 'en'
  });

  return `https://maps.googleapis.com/maps/api/geocode/json?${params}`;
}

function doGoogleRequest(address) {
  return axios.get(makeGoogleQueryUrl(address))
    .then((response) => {
      console.debug(response);

      if (response.data.status === 'OK') {
        return response.data.results.map(item => {
          return {
            value: item.place_id,
            label: item.formatted_address,
          };
        });
      }

      return [];
    })
    .catch((error) => {
      console.error(error);
    });
}

let typedAddress = ref('');
let selectedAddressItem = ref<any>(null);
let isBusy = ref(false);

let suggestionResults = ref<{
  label: string
  value: string
}[]>([]);

const handleAddressInput = debounce(() => {
  if (typedAddress.value.length < 3)
    return;

  isBusy.value = true;
  selectedAddressItem.value = null;

  doGoogleRequest(typedAddress.value)
    .then((data) => {
      suggestionResults.value = data;
    })
    .finally(() => {
      isBusy.value = false;
    });
}, 800);

function handleSuggestedItemClick(item: any) {
  console.debug(item);

  selectedAddressItem.value = item;

  emit('update:modelValue', item);
}
</script>

<template>
  <div>
    <div class="form-group">
      <label class="form-label">Start typing your address</label>
      <input
        v-model="typedAddress"
        type="text"
        class="form-control"
        :placeholder="placeholder || 'Example: 1135 South Michigan Ave'"
        @input="handleAddressInput"
      >
    </div>

    <div>
      <template v-if="isBusy">
        Loading...
      </template>
      <template v-else>
        <template v-if="suggestionResults.length">
          <h6 class="mt-3 mb-3">
            Choose Location
          </h6>

          <div
            class="list-group list-group-item-action"
          >
            <a
              v-for="(item, index) in suggestionResults"
              :key="index"
              href="#"
              class="list-group-item list-group-item-action"
              :class="{active: item.value == selectedAddressItem?.value}"
              @click="handleSuggestedItemClick(item)"
            >
              {{ item.label }}
            </a>
          </div>
        </template>
        <template v-else>
          <span
            v-if="typedAddress.length"
            class="text-muted"
          >
            No results...
          </span>
        </template>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
